import React, { useState } from 'react';

import { TAppointment } from 'ui-model';

import AppointmentCancelButton from './components/AppointmentCancelButton';
import AppointmentRescheduleSMSButton from './components/AppointmentRescheduleSMSButton';

export interface IAppointmentItemActionButtons {
  appointment: TAppointment;
  isRescheduleEnabled: boolean;
}

export enum ACTION_STATUS {
  Initial = 'initial',
  Canceled = 'canceled',
  Rescheduled = 'rescheduled',
}

const AppointmentItemActionButtons = (props: IAppointmentItemActionButtons) => {
  const { appointment, isRescheduleEnabled } = props;
  const [actionStatus, setActionsStatus] = useState<ACTION_STATUS>(ACTION_STATUS.Initial);

  return (
    <>
      {actionStatus !== ACTION_STATUS.Canceled && (
        <AppointmentRescheduleSMSButton
          appointmentId={appointment._id}
          disabled={!isRescheduleEnabled || actionStatus === ACTION_STATUS.Rescheduled}
        />
      )}
      {actionStatus !== ACTION_STATUS.Rescheduled && (
        <AppointmentCancelButton
          appointmentId={appointment._id}
          disabled={!isRescheduleEnabled || actionStatus === ACTION_STATUS.Canceled}
          setActionsStatus={setActionsStatus}
        />
      )}
    </>
  );
};

export default AppointmentItemActionButtons;
